import {
  Component,
  ChangeDetectionStrategy,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { UsernameStorageService } from '../../../services/username-storage.service';
import { GameSocketService } from '../../../services/socket.service';
import { RoomChromeService } from '../../../services/room-chrome.service';

@Component({
  selector: 'snk-main-layout',
  // NOTE: keep heavy libs (e.g. lucide-angular) out of this component — it is
  // eagerly loaded, so anything imported here lands in the initial bundle.
  imports: [RouterOutlet, RouterLink],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent {
  private usernameStorage = inject(UsernameStorageService);
  private socketService = inject(GameSocketService);
  private roomChrome = inject(RoomChromeService);
  private router = inject(Router);

  readonly username = this.usernameStorage.getUsername();

  /** Room identity published by the room page; null outside a room. */
  readonly roomInfo = this.roomChrome.roomInfo;

  readonly connectionStatus = toSignal(this.socketService.connectionStatus$, {
    initialValue: { connected: false, connecting: false, error: '' },
  });

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  /** True while viewing a game room — shows the controls hint in the footer. */
  readonly isRoomRoute = computed(() =>
    this.currentUrl().startsWith('/room/')
  );

  copyRoomLink(): void {
    void this.roomChrome.copyRoomLink();
  }

  requestLeave(): void {
    this.roomChrome.requestLeave();
  }
}
